<div class="container-fuild">
    <div class="row pt-4 d-flex align-items-center">
        <div class="col-md-8 step-title p-0">
            <h5 class="mb-0">Get Receipts</h5>
            <p class="mb-0" style="font-size:14px">Get Receipts Details of Petition</p>
        </div>
        
        <div class="col-md-4 editBtn headerSubPortion px-0"> 
            <ul>
              <li class="col-auto px-0 firstPortion"> 
                <gc-status-update [stepDetails]="stepDetails" type="EDIT"></gc-status-update>
              </li>
              <li class="col-auto pr-0 pl-2 secondPortion">
                <lib-maximize-dialog-library [configData]="{'layoutCode':stepDetails?.stepActionList[0].layoutCode}"></lib-maximize-dialog-library>
            <i (click)="handleClose();" class="close-icon pi pi-times pull-right"></i>
              </li>
            </ul>
          </div>
    </div>
    <div class="row"> 
        <div class="col-md-12 p-0">
            <lib-assigning-task-library  [stepDetails]="stepDetails" (updateStatus)="updateStepStatus($event)">
            </lib-assigning-task-library>
        </div>
    </div>
    <p-divider></p-divider>
    <form (ngSubmit)="postGetReceipts()" #getReceiptsForm="ngForm" class="pb-3 pt-2">
        <div class="main-body">
            <div class="row mb-3">
                <div class="col-md-3 form-group input-disabled">
                    <label class="label-cls required"> Receipt Number</label>
                    <input type="text" class="im-input mw-100" name="receiptNumber" #receiptNumber="ngModel"
                        [readOnly]="disabledControls" placeholder="Enter" [(ngModel)]="receiptDetails.receiptNumber" [pattern]="receiptNumberRegexp"
                        pInputText required/>
                    <div
                        *ngIf="getReceiptsForm.controls['receiptNumber'].touched && getReceiptsForm.controls['receiptNumber'].invalid">
                        <span class="invalid-message"
                            *ngIf="getReceiptsForm.controls['receiptNumber'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
  
                        <span  class="invalid-message" *ngIf="getReceiptsForm.controls['receiptNumber'].errors?.pattern">{{ getGlobalErrorMessages("INVALID_FORMAT") }}</span>
                    </div>
                </div>
                <div class="col-md-3  calendar-input">
                    <label class="label-cls required"> Receipt Date </label>
                    <p-calendar type="text" name="receiptDate" class="mw-100" id="receiptDate" appendTo="body"
                        [(ngModel)]="receiptDetails.receiptDate" [disabled]="disabledControls" inputId="icon"
                        [showIcon]="true" dateFormat="mm/dd/yy"  [maxDate]="receiptMaxDate" yearRange="1910:2050"
                        [monthNavigator]="true" [yearNavigator]="true"  placeholder="MM/DD/YYYY" required> </p-calendar>
                    <div
                        *ngIf="getReceiptsForm.controls['receiptDate'].touched && getReceiptsForm.controls['receiptDate'].invalid">
                        <span class="invalid-message" *ngIf="getReceiptsForm.controls['receiptDate'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-12 p-0">
                    <i140-file-upload style="width: 100%;" [fileUploadConfigurations]="fileUploadConfigurations">
                    </i140-file-upload>
                </div>
            </div>
        </div>
        <p-divider></p-divider>
        <div class="row pt-3">
            <div class="col-md-2">
                <button pButton type="submit" label="Save" class="save-btn" icon="pi pi-save"
                    [ngClass]="getReceiptsForm.invalid  || disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
                    [disabled]="getReceiptsForm.invalid  || disabledControls"></button>
            </div>
            <div class="col-md-2">
                <button pButton type="button" label="Cancel" 
                icon="pi pi-times-circle" class="p-button-secondary cancel-btn button-width-icon-left 
                d-flex alogn-items-center" [disabled]="disabledControls" (click)="handleCancel()">
                </button>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-6">
                <gc-status-update [stepDetails]="stepDetails" [type]="typeOfButton" [showPreviousStepBtn]="showPrev" [showNextStepBtn]="showNext" class="d-flex col-12 justify-content-end"></gc-status-update>
            </div>
        </div>
    </form>
</div>